import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MngActionDef, MngButtonComponent, MngDialogHeaderComponent } from '@mng/mng-inputs';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  imports: [MngDialogHeaderComponent, MatDialogContent, MatDialogActions, MngButtonComponent],
  template: `
    <mng-dialog-header title="Session abgelaufen" iconName="alert" iconColor="warning" />

    <mat-dialog-content [innerHtml]="infoText" />

    <mat-dialog-actions align="end">
      <mng-button [actionDef]="actionDef" />
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MngSessionExpiredDialogComponent {
  actionDef: MngActionDef;

  infoText!: SafeHtml;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { infoText?: string },
    domSanitizer: DomSanitizer
  ) {
    const infoText =
      data.infoText ??
      `Sie wurden abgemeldet da Sie längere Zeit nicht im Merkur-Portal aktiv waren. Bitte melden Sie sich erneut an.`;
    this.actionDef = new MngActionDef().withAction(() => this.reloadApp()).withTitle('Anmelden');
    this.infoText = domSanitizer.bypassSecurityTrustHtml(infoText);
  }

  reloadApp() {
    location.reload();
  }
}
